import { render, staticRenderFns } from "./reportsSA.vue?vue&type=template&id=9fe66432&scoped=true"
import script from "./reportsSA.vue?vue&type=script&lang=js"
export * from "./reportsSA.vue?vue&type=script&lang=js"
import style0 from "./reportsSA.vue?vue&type=style&index=0&id=9fe66432&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fe66432",
  null
  
)

export default component.exports